import React from 'react';

const WindowIcon = () => (
  <svg width="11px" height="11px" viewBox="0 0 11 11">
    <g id="Blinds.com" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g id="Measure-and-Installation-/-My-Properties" transform="translate(-290.000000, -374.000000)">
        <g id="Main-Content" transform="translate(29.000000, 284.000000)">
          <g id="Home-Property">
            <g id="Order-Table" transform="translate(0.000000, 87.000000)">
              <g id="Measured-Windows">
                <g id="Header">
                  <g id="Dark-Window-Icon" transform="translate(261.000000, 3.000000)">
                    <path
                      d="M6,2 L6,5 L9,5 L9,2 L6,2 Z M5,2 L2,2 L2,9 L9,9 L9,6 L6,6 L6,9 L5,9 L5,6 L2,6 L2,5 L5,5 L5,2 Z M1.5,11 L0,11 L0,1.77635684e-15 L1,1.77635684e-15 L11,2.77555756e-15 L11,1 L11,10 L11,11 L1.5,11 Z"
                      id="Combined-Shape"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default WindowIcon;
